module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Vynil-e91ee4b1566a150a5ef56c9a7738773e.svg";